import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const features = [
    {
      id: 1,
      icon: "Brain",
      title: "AI Classification",
      description: "Automatically categorizes your input into marketing, legal, image, video, or technical domains for precise prompt generation.",
      color: "var(--color-primary)"
    },
    {
      id: 2,
      icon: "Lightbulb",
      title: "Intelligent Suggestions",
      description: "Get three tailored prompt suggestions with one highlighted as recommended, powered by advanced GPT integration.",
      color: "var(--color-accent)"
    },
    {
      id: 3,
      icon: "Settings",
      title: "Workflow Customization",
      description: "Build custom workflows with master prompt systems and save your favorite prompts for future use across projects.",
      color: "var(--color-success)"
    }
  ];

  return (
    <section className="py-20 lg:py-32 bg-surface">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-text-primary">
            Powerful Features for
            <span className="block text-primary">Every Use Case</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            From marketing campaigns to legal documents, our AI understands your needs and delivers precisely crafted prompts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features?.map((feature) => (
            <div
              key={feature?.id}
              className="group bg-card border border-border rounded-xl p-8 hover:shadow-modal transition-state hover-scale"
            >
              <div className="space-y-6">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center`} 
                     style={{ backgroundColor: `${feature?.color}15` }}>
                  <Icon 
                    name={feature?.icon} 
                    size={32} 
                    color={feature?.color} 
                  />
                </div>
                
                <div className="space-y-3">
                  <h3 className="text-xl font-semibold text-text-primary group-hover:text-primary transition-smooth">
                    {feature?.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {feature?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Feature Highlights */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { icon: "Clock", label: "Instant Results", value: "< 3 seconds" },
            { icon: "Target", label: "Accuracy Rate", value: "95%" },
            { icon: "Layers", label: "Categories", value: "5+ Domains" },
            { icon: "Bookmark", label: "Save & Organize", value: "Unlimited" }
          ]?.map((stat, index) => (
            <div key={index} className="text-center space-y-3">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto">
                <Icon name={stat?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="space-y-1">
                <div className="text-2xl font-bold text-text-primary">{stat?.value}</div>
                <div className="text-sm text-text-secondary">{stat?.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;